import { useEffect, useState, useCallback } from "react";
import { translations, supportedLocales } from "@/i18n/translations";

const STORAGE_KEY = "aethron.locale";

function detectInitial() {
  if (typeof window === "undefined") return "en";
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored && supportedLocales.includes(stored)) return stored;
  const browser = (navigator.language || "en").slice(0, 2).toLowerCase();
  return supportedLocales.includes(browser) ? browser : "en";
}

export function useI18n() {
  const [locale, setLocaleState] = useState(detectInitial);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, locale);
      document.documentElement.lang = locale;
    }
  }, [locale]);

  const setLocale = useCallback((l) => {
    if (supportedLocales.includes(l)) setLocaleState(l);
  }, []);

  const toggle = useCallback(() => {
    setLocaleState((prev) => (prev === "en" ? "de" : "en"));
  }, []);

  const t = translations[locale] || translations.en;

  return { locale, t, setLocale, toggle };
}
